<template>
  <div
    class="cmp-property-slider"
    :class="{
      applied: propApplied,
    }"
  >
    <template v-if="inEdit">
      <ws-checkbox v-model="propApplied" class="text-bold" full-width>
        <template v-slot>
          <price-period
            v-if="propPrice"
            class="float-right"
            plain
            :price="propPrice.actualPrice"
            :between="model.volume ? '' : '/GB'"
            :period="propPrice.period"
            individual
          />
          <small
            v-if="label"
            class="checkbox-label"
            :class="propApplied ? 'text-ws-base150' : 'text-ws-base110'"
          >{{ $t(label) }}</small>
        </template>
      </ws-checkbox>

      <ws-slider
        v-if="propApplied"
        v-model="model.volume"
        label-always
        position="bottom"
        :disable="!propApplied"
        :config="propConfig"
        @input="reEmit({ ...model, volume: $event })"
      />
    </template>
    <template v-else>
      <price-period
        class="float-right"
        :price="propPrice.actualPrice"
        :period="propPrice.period"
        individual
      />
      <span v-if="label" class="text-ws-base150">{{ $t(label) }}</span>
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { cloneDeep } from 'lodash-es';
import WsCheckbox from '@WS_Components/WsCheckbox.vue';
import WsSlider from '@/components/WsSlider.vue';
import PricePeriod from '@/components/PricePeriod.vue';

@Component({
  components: {
    WsCheckbox,
    WsSlider,
    PricePeriod,
  },
})
export default class PropertySlider extends Vue {
  @Prop(String)
  readonly label!: string;
  @Prop({ default: () => ({}) })
  readonly value!: any;
  @Prop({ default: 12 })
  readonly period!: number;
  @Prop(Boolean)
  readonly inEdit!: boolean;
  propApplied = false;

  get model() {
    if (this.value.volume) {
      this.propApplied = true;
    }
    return { volume: 0, ...this.value };
  }
  set model(value: any) {
    this.reEmit(value);
  }

  get propConfig() {
    const model = this.model ?? {};

    return {
      unit: model.unit ?? 'GB',
      min: model.min,
      max: model.max,
      color: 'primary',
    };
  }

  get propPrice() {
    const price = cloneDeep(
      this.model?.price ??
        this.model?.prices?.find((p: any) => p.period === this.period) ??
        {}
    );
    price.period = price.period ?? this.period;

    if (price.actualPrice === null) {
      return price;
    }

    price.actualPrice *= this.model.volume || 1;
    return price;
  }

  @Watch('propApplied')
  onPropAppliedChanged(propApplied: boolean) {
    this.reEmit({
      ...this.model,
      volume: propApplied ? this.model?.volume || this.model?.min || 1 : 0,
    });
  }

  reEmit(value?: any) {
    this.$emit('input', value ?? this.model);
  }
}
</script>

<style lang="scss" scoped>
.cmp-property-slider {
  .checkbox-label {
    vertical-align: middle;
  }

  &:not(.applied) {
    .cmp-price-period ::v-deep {
      .price,
      .period {
        color: $ws-base100;
        font-weight: normal;
      }
    }
  }
}
</style>
